import React from 'react';

function Footer() {
    return (
        <footer className="bg-white">
            <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
                <p className="text-center text-sm text-gray-500">
                    © 2025 Akhil Bhartiya Swarnkar Samaj Vikas Evam Shodh Sansthan. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;

